export class AusApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSubmitOperations(loanId) {
    return this.#http.get(`loan/${loanId}/aus/submit/operations`);
  }

  async getSubmitOperationById(loanId, operationId) {
    return this.#http.get(`loan/${loanId}/aus/submit/operations/${operationId}`);
  }
}
